import { render, staticRenderFns } from "./invoice-status-changer.vue?vue&type=template&id=8715052e&scoped=true"
import script from "./invoice-status-changer.vue?vue&type=script&lang=js"
export * from "./invoice-status-changer.vue?vue&type=script&lang=js"
import style0 from "./invoice-status-changer.vue?vue&type=style&index=0&id=8715052e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715052e",
  null
  
)

export default component.exports